// Bus de eventos mínimo. Desacopla lógica ↔ UI ↔ red ↔ audio.
// La lógica del juego emite eventos; la presentación los escucha.

export class EventBus {
  constructor() {
    /** @type {Map<string, Set<Function>>} */
    this._handlers = new Map();
  }

  on(event, handler) {
    if (!this._handlers.has(event)) this._handlers.set(event, new Set());
    this._handlers.get(event).add(handler);
    return () => this.off(event, handler); // devuelve función de baja
  }

  once(event, handler) {
    const wrapper = (payload) => {
      this.off(event, wrapper);
      handler(payload);
    };
    return this.on(event, wrapper);
  }

  off(event, handler) {
    const set = this._handlers.get(event);
    if (set) set.delete(handler);
  }

  emit(event, payload) {
    const set = this._handlers.get(event);
    if (!set) return;
    // Copia defensiva por si un handler se da de baja durante la emisión.
    for (const handler of [...set]) {
      try {
        handler(payload);
      } catch (err) {
        console.error(`[EventBus] Error en handler de "${event}":`, err);
      }
    }
  }

  clear() {
    this._handlers.clear();
  }
}

// Instancia global compartida por toda la aplicación.
export const bus = new EventBus();
